import * as React from "react"

export default class BaseModal<P = {}, S = {}>
extends React.Component<BaseModalProps & P, S> {}

export interface BaseModalProps {
	active?: boolean
	isFluid?: boolean
	onClickCloseButton(event: React.SyntheticEvent<Element>): void
	clickable?:boolean
}



// WEBPACK FOOTER //
// ./src/component/modal/base-modal.tsx